module.exports = __webpack_public_path__ + "img/40_38_030_110.cefc2a5c.jpg";